<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";

/**
 * Alerts component
 */
export default {
  page: {
    title: "Alerts",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      title: "Alerts",
      items: [
        {
          text: "UI Elements",
          href: "/",
        },
        {
          text: "Alerts",
          active: true,
        },
      ],
      dismissSecs: 5,
      dismissCountDown: 0,
    };
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
  },
};
</script>

<template>
  <Layout :pagetitle="title">
    <div class="row">
      <div class="col-xl-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Default Alerts</h4>
          </div>
          <div class="card-body">
            <p class="card-title-desc">
              Alerts are available for any length of text, as well as an
              optional dismiss button. For proper styling, use one of the four
              <strong>required</strong> contextual classes (e.g.,
              <code>.alert-success</code>).
            </p>

            <div class="">
              <div class="alert alert-primary" role="alert">
                A simple primary alert—check it out!
              </div>
              <div class="alert alert-secondary" role="alert">
                A simple secondary alert—check it out!
              </div>
              <div class="alert alert-success" role="alert">
                A simple success alert—check it out!
              </div>
              <div class="alert alert-danger" role="alert">
                A simple danger alert—check it out!
              </div>
              <div class="alert alert-warning" role="alert">
                A simple warning alert—check it out!
              </div>
              <div class="alert alert-info mb-0" role="alert">
                A simple info alert—check it out!
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->

      <div class="col-xl-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Link color</h4>
          </div>
          <div class="card-body">
            <p class="card-title-desc">
              Use the <code>.alert-link</code> utility class to quickly provide
              matching colored links within any alert.
            </p>

            <div class="">
              <div class="alert alert-primary" role="alert">
                A simple primary alert with
                <a href="javascript: void(0);" class="alert-link"
                  >an example link</a
                >. Give it a click if you like.
              </div>
              <div class="alert alert-secondary" role="alert">
                A simple secondary alert with
                <a href="javascript: void(0);" class="alert-link"
                  >an example link</a
                >. Give it a click if you like.
              </div>
              <div class="alert alert-success" role="alert">
                A simple success alert with
                <a href="javascript: void(0);" class="alert-link"
                  >an example link</a
                >. Give it a click if you like.
              </div>
              <div class="alert alert-danger" role="alert">
                A simple danger alert with
                <a href="javascript: void(0);" class="alert-link"
                  >an example link</a
                >. Give it a click if you like.
              </div>
              <div class="alert alert-warning" role="alert">
                A simple warning alert with
                <a href="javascript: void(0);" class="alert-link"
                  >an example link</a
                >. Give it a click if you like.
              </div>
              <div class="alert alert-info mb-0" role="alert">
                A simple info alert with
                <a href="javascript: void(0);" class="alert-link"
                  >an example link</a
                >. Give it a click if you like.
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-xl-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Dismissing</h4>
          </div>
          <div class="card-body">
            <p class="card-title-desc">
              Add a dismiss button and the
              <code>.alert-dismissible</code> class, which adds extra padding to
              the right of the alert and positions the
              <code>.btn-close</code> button.
            </p>
            <div class="">
              <div
                class="alert alert-primary alert-dismissible fade show"
                role="alert"
              >
                A simple primary alert—check it out!
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
              <div
                class="alert alert-secondary alert-dismissible fade show"
                role="alert"
              >
                A simple secondary alert—check it out!
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
              <div
                class="alert alert-success alert-dismissible fade show"
                role="alert"
              >
                A simple success alert—check it out!
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
              >
                A simple danger alert—check it out!
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
              <div
                class="alert alert-warning alert-dismissible fade show"
                role="alert"
              >
                A simple warning alert—check it out!
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
              <div
                class="alert alert-info alert-dismissible fade show mb-0"
                role="alert"
              >
                A simple info alert—check it out!
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->

      <div class="col-xl-6">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">With Icon</h4>
          </div>
          <div class="card-body">
            <div class="">
              <div
                class="alert alert-primary alert-dismissible fade show"
                role="alert"
              >
                <i class="mdi mdi-bullseye-arrow me-2"></i>
                A simple primary alert—check it out!
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
              <div
                class="alert alert-secondary alert-dismissible fade show"
                role="alert"
              >
                <i class="mdi mdi-grease-pencil me-2"></i>
                A simple secondary alert—check it out!
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
              <div
                class="alert alert-success alert-dismissible fade show"
                role="alert"
              >
                <i class="mdi mdi-check-all me-2"></i>
                A simple success alert—check it out!
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
              >
                <i class="mdi mdi-block-helper me-2"></i>
                A simple danger alert—check it out!
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
              <div
                class="alert alert-warning alert-dismissible fade show"
                role="alert"
              >
                <i class="mdi mdi-alert-outline me-2"></i>
                A simple warning alert—check it out!
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
              <div
                class="alert alert-info alert-dismissible fade show mb-0"
                role="alert"
              >
                <i class="mdi mdi-alert-circle-outline me-2"></i>
                A simple info alert—check it out!
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="alert"
                  aria-label="Close"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
